import { AxiosError } from 'axios'

import { publishRumEvent } from './publish-rum-event'

import { SPLUNK_RUM_FIELDS, SplunkRumWorkflows } from '@/constants/splunk'

export function publishAxiosRumErrorEvent(
  workflow: SplunkRumWorkflows[keyof SplunkRumWorkflows],
  axiosError: AxiosError,
) {
  publishRumEvent({
    [SPLUNK_RUM_FIELDS.WORKFLOW]: workflow,
    [SPLUNK_RUM_FIELDS.RESPONSE_STATUS]: String(
      axiosError?.response?.status ?? '',
    ),
    [SPLUNK_RUM_FIELDS.RESPONSE_BODY]: JSON.stringify(
      axiosError?.response?.data,
    ),
  })
}
